// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"AddOnCheckbox_checkbox__Dlgsb","icon":"AddOnCheckbox_icon__wbZv3","checkboxComponent":"AddOnCheckbox_checkboxComponent__aDt69"};